import { render } from "./roomAdd.vue?vue&type=template&id=b9c4bb82&scoped=true"
import script from "./roomAdd.vue?vue&type=script&lang=js"
export * from "./roomAdd.vue?vue&type=script&lang=js"

import "./roomAdd.vue?vue&type=style&index=0&id=b9c4bb82&scoped=true&lang=css"

import exportComponent from "D:\\git\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9c4bb82"]])

export default __exports__